import { render, staticRenderFns } from "./billDetails_wx.vue?vue&type=template&id=4497c7c1"
import script from "./billDetails_wx.vue?vue&type=script&lang=js"
export * from "./billDetails_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports